import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./VotingRadioButtonList.module.css";
import RadioButton from "shared/@forms/RadioButton";
import { nanoid } from "nanoid";

/**
 * Interactive component. Radio buttons for on, off, and closed. Each radio button has a different color
 */
export function VotingRadioButtonList({ onClick, status, readOnly = false }) {
  const id = nanoid();
  return (
    <div className={styles.buttonContainer}>
      <div className={styles.offContainer}>
        <label htmlFor={`off-${id}`}>Off</label>
        <RadioButton
          type="radio"
          id={`off-${id}`}
          name={`voting_radio_list${id}`}
          value="off"
          onClick={() => {
            onClick("off");
          }}
          className={styles.offButton}
          checked={status === "off"}
          readOnly={readOnly}
        />
      </div>
      <div className={styles.onContainer}>
        <label htmlFor={`on-${id}`}>On</label>
        <RadioButton
          type="radio"
          id={`on-${id}`}
          name={`voting_radio_list${id}`}
          value="on"
          onClick={() => {
            onClick("on");
          }}
          className={styles.onButton}
          checked={status === "on"}
          readOnly={readOnly}
        />
      </div>
      <div className={styles.closedContainer}>
        <label htmlFor={`closed-${id}`}>Closed</label>
        <RadioButton
          type="radio"
          id={`closed-${id}`}
          name={`voting_radio_list${id}`}
          value="closed"
          onClick={() => {
            onClick("closed");
          }}
          className={styles.closedButton}
          checked={status === "closed"}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}

VotingRadioButtonList.propTypes = { onClick: PropTypes.func };
